import ReactPlayer from "react-player/vimeo";
import styled from "styled-components";
// import Contact from "./Contact";

const Project = ({video, link, Text}) => {

    const github = `https://www.github.com/impregnablequestion/${link}`

    return(
        <ProjectContainer>
            <TextContainer>
              <Text/>
            </TextContainer>
            <VideoContainer>
                <h2>demo video:</h2>
                <ReactPlayer url={video} controls/>
                <a href={github} target="_blank" rel="noreferrer">code on github</a>
            </VideoContainer>
        </ProjectContainer>
    )
}

const ProjectContainer = styled.div`
    display: flex;
    justify-content: center;
    gap: 1rem;
    align-items: center;
    flex-wrap: wrap;
    padding: 1.5rem;
    padding-top: 5rem;
    /* border: 1px solid white; */
`

const TextContainer = styled.div`
    color: white;
    font-size: 16px;
    max-width: 28rem;
    background: rgba(0, 0, 0, 0.75);
    /* border-radius: 1rem; */
    padding: 0.5rem;
    /* border: 0.1px solid white; */
`

const VideoContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1.5rem;
`

export default Project;